<template>
  <Button @click="persistListView" color="primary" class="mb-2" :disabled="disabled">Save</Button>
</template>

<script>
import Button from '@wizer/core/components/button/Button'
import { isEqual } from 'lodash'
import ChartDataService from '@/services/ChartDataService'

export default {
  name: 'SaveButton',
  components: { Button },
  data() {
    return {
      disabled: false,
    }
  },
  methods: {
    async persistListView() {
      const chartParameters = {
        routeName: this.$route.name,
        ...this.$route.query,
      }
      try {
        this.disabled = true
        const visualizationId = (await ChartDataService.persistChartParameters(chartParameters))
          .data

        const route = this.getRoute(visualizationId)
        if (!isEqual(this.$route.query, route.query)) {
          this.$router.push(route)
        }
      } finally {
        this.disabled = false
      }
    },
    getRoute(visualizationId) {
      return {
        name: this.$route.name,
        query: {
          ...this.$route.query,
          visualizationId,
        },
      }
    },
  },
}
</script>
<style lang="postcss" scoped></style>
